/**
 * GENERATED by script/gen-calendar.mjs from this runtime's ICU data. DO NOT EDIT.
 *
 * Class G of docs/plan/07 §3.1 — the lunisolar occasions, resolved to Gregorian
 * dates once at build time and frozen. Regenerate with `npm run gen:calendar`;
 * `npm run check:calendar` fails CI if this file and the generator disagree.
 *
 * ⚠ ADMIN AND WORKER ONLY. `extensions/rollup-plugin-no-calendar.js` fails the
 * storefront build on any import that reaches this file. Twenty years of sixty
 * occasions is the exact thing the baked-window design exists to keep out of a
 * shopper's bundle.
 *
 * Horizon: 2026–2035. Past it every lookup returns null and the admin says the
 * occasion needs updating. A wrong Diwali is worse than a missing one.
 */

/**
 * Gregorian [month, day] pairs. An ARRAY per year because a Gregorian year can
 * hold two occurrences of a Hijri feast — see gotcha 3 in the generator.
 */
export type GeneratedTable = Record<string, Record<number, Array<[number, number]>>>;

export const GENERATED_FROM_YEAR = 2026;
export const GENERATED_TO_YEAR = 2035;

export const GENERATED: GeneratedTable = {
  'ramadan': {
    2026: [[2, 18]],
    2027: [[2, 8]],
    2028: [[1, 28]],
    2029: [[1, 16]],
    2030: [[1, 5], [12, 26]],
    2031: [[12, 16]],
    2032: [[12, 4]],
    2033: [[11, 23]],
    2034: [[11, 12]],
    2035: [[11, 1]],
  },
  'eid-al-fitr': {
    2026: [[3, 20]],
    2027: [[3, 9]],
    2028: [[2, 26]],
    2029: [[2, 14]],
    2030: [[2, 4]],
    2031: [[1, 24]],
    2032: [[1, 14]],
    2033: [[1, 3], [12, 23]],
    2034: [[12, 12]],
    2035: [[12, 1]],
  },
  'eid-al-adha': {
    2026: [[5, 27]],
    2027: [[5, 16]],
    2028: [[5, 5]],
    2029: [[4, 24]],
    2030: [[4, 13]],
    2031: [[4, 2]],
    2032: [[3, 22]],
    2033: [[3, 12]],
    2034: [[3, 1]],
    2035: [[2, 19]],
  },
  'rosh-hashanah': {
    2026: [[9, 12]],
    2027: [[10, 2]],
    2028: [[9, 21]],
    2029: [[9, 10]],
    2030: [[9, 28]],
    2031: [[9, 18]],
    2032: [[9, 6]],
    2033: [[9, 24]],
    2034: [[9, 14]],
    2035: [[10, 4]],
  },
  'yom-kippur': {
    2026: [[9, 21]],
    2027: [[10, 11]],
    2028: [[9, 30]],
    2029: [[9, 19]],
    2030: [[10, 7]],
    2031: [[9, 27]],
    2032: [[9, 15]],
    2033: [[10, 3]],
    2034: [[9, 23]],
    2035: [[10, 13]],
  },
  'hanukkah': {
    2026: [[12, 5]],
    2027: [[12, 25]],
    2028: [[12, 13]],
    2029: [[12, 2]],
    2030: [[12, 21]],
    2031: [[12, 10]],
    2032: [[11, 28]],
    2033: [[12, 17]],
    2034: [[12, 7]],
    2035: [[12, 26]],
  },
  'passover': {
    2026: [[4, 2]],
    2027: [[4, 22]],
    2028: [[4, 11]],
    2029: [[3, 31]],
    2030: [[4, 18]],
    2031: [[4, 8]],
    2032: [[3, 27]],
    2033: [[4, 14]],
    2034: [[4, 4]],
    2035: [[4, 24]],
  },
  'purim': {
    2026: [[3, 3]],
    2027: [[3, 23]],
    2028: [[3, 12]],
    2029: [[3, 1]],
    2030: [[3, 19]],
    2031: [[3, 9]],
    2032: [[2, 26]],
    2033: [[3, 15]],
    2034: [[3, 5]],
    2035: [[3, 25]],
  },
  'lunar-new-year': {
    2026: [[2, 17]],
    2027: [[2, 7]],
    2028: [[1, 26]],
    2029: [[2, 13]],
    2030: [[2, 2]],
    2031: [[1, 23]],
    2032: [[2, 11]],
    2033: [[1, 31]],
    2034: [[2, 19]],
    2035: [[2, 8]],
  },
  'lantern-festival': {
    2026: [[3, 3]],
    2027: [[2, 21]],
    2028: [[2, 9]],
    2029: [[2, 27]],
    2030: [[2, 16]],
    2031: [[2, 6]],
    2032: [[2, 25]],
    2033: [[2, 14]],
    2034: [[3, 5]],
    2035: [[2, 22]],
  },
  'dragon-boat': {
    2026: [[6, 19]],
    2027: [[6, 9]],
    2028: [[5, 28]],
    2029: [[6, 16]],
    2030: [[6, 5]],
    2031: [[6, 24]],
    2032: [[6, 12]],
    2033: [[6, 1]],
    2034: [[6, 20]],
    2035: [[6, 10]],
  },
  'qixi': {
    2026: [[8, 19]],
    2027: [[8, 8]],
    2028: [[8, 26]],
    2029: [[8, 16]],
    2030: [[8, 5]],
    2031: [[8, 24]],
    2032: [[8, 12]],
    2033: [[8, 1]],
    2034: [[8, 20]],
    2035: [[8, 10]],
  },
  'mid-autumn': {
    2026: [[9, 25]],
    2027: [[9, 15]],
    2028: [[10, 3]],
    2029: [[9, 22]],
    2030: [[9, 12]],
    2031: [[10, 1]],
    2032: [[9, 19]],
    2033: [[9, 8]],
    2034: [[9, 27]],
    2035: [[9, 16]],
  },
  'seollal': {
    2026: [[2, 17]],
    2027: [[2, 7]],
    2028: [[1, 27]],
    2029: [[2, 13]],
    2030: [[2, 3]],
    2031: [[1, 23]],
    2032: [[2, 11]],
    2033: [[1, 31]],
    2034: [[2, 19]],
    2035: [[2, 8]],
  },
  'chuseok': {
    2026: [[9, 25]],
    2027: [[9, 15]],
    2028: [[10, 3]],
    2029: [[9, 22]],
    2030: [[9, 12]],
    2031: [[10, 1]],
    2032: [[9, 19]],
    2033: [[9, 8]],
    2034: [[9, 27]],
    2035: [[9, 16]],
  },
};
